import { inventoryCategoryService } from "../../../../../Api/Services/InventoryService/inventoryCategory";
import { ACTION_NAMES, SLICE_NAMES } from "../../../../../constants/action";
import { ERROR_MESSAGES } from "../../../../../constants/error";
import createGenericSlice from "../../../../../utils/reduxUtils/createEntitySlice";
import createServiceAsyncThunk from "../../../../../utils/reduxUtils/createServiceAsyncThunk";
import { InventoryCategoryListResponse } from "../../types";

// Fetch categories
export const fetchInventoryCategories = createServiceAsyncThunk<
  InventoryCategoryListResponse,
  { page?: number; size?: number; name?: string; status?: number }
>(
  ACTION_NAMES.FETCH_INVENTORY_CATEGORY_LIST,
  (params) => inventoryCategoryService.getCategories(params),
  ERROR_MESSAGES.FETCH_INVENTORY_CATEGORY_FAILURE
);


export const inventoryCategorySlice = createGenericSlice<
  InventoryCategoryListResponse,
  { page?: number; size?: number; name?: string; status?: number }
>(
  SLICE_NAMES.INVENTORY_CATEGORY_LIST_SLICE,
  fetchInventoryCategories
);

export const {
  clearError: clearInventoryCategoryListError,
  clearSuccessMessage: clearInventoryCategoryListSuccessMessage,
} = inventoryCategorySlice.actions;

export default inventoryCategorySlice.reducer;
